/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react';
import ApartmentIcon from '@mui/icons-material/Apartment';
import {
  Avatar,
  Button,
  Box,
  Divider,
  Hidden,
  lighten,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography,
  darken,
  alpha,
  Fade,
  IconButton,
  Tabs,
  Tab,
  Tooltip
} from '@mui/material';
import { Button as SrcButton } from 'src/components';
import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import RefreshIcon from '@mui/icons-material/Refresh';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import BadgeIcon from '@mui/icons-material/Badge';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import SaveIcon from '@mui/icons-material/Save';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BusinessIcon from '@mui/icons-material/Business';
import PrintIcon from '@mui/icons-material/Print';
import PaletteIcon from '@mui/icons-material/Palette';
import ViewSidebarIcon from '@mui/icons-material/ViewSidebar';
import FormatSizeIcon from '@mui/icons-material/FormatSize';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

//import { createBrowserHistory as history} from 'history';
import { useNavigate } from 'react-router';

import { Chip, Dialog, FormControl, FormLabel, Grid, Select, Stack } from 'src/components';
import { helper } from 'src/utils/helper';
import { CloudDownload, Mail, PrintRounded, TaskAlt, Warehouse } from '@mui/icons-material';
import printService, { printerModel } from 'src/services/Printer/print.service';
import notify from 'src/utils/SnackbarUtils';
import { CustomThemeContext } from 'src/theme/ThemeProvider';
import ThemeChoose from './themem.choose';
import { Formik } from 'formik';
import PrinterRequest from 'src/models/Printer/Request/PrinterRequest';
import KullaniciPrinterDTOService from 'src/services/Printer/KullaniciPrinterDTO.service';
import SnackbarUtils from 'src/utils/SnackbarUtils';
import { useConfirmation } from 'src/base/ConfirmationDialog/ConfirmationService';
import PasswordIcon from '@mui/icons-material/Password';
import SifreDegistir from 'src/content/pages/Login/sifreDegistir';
import { useAppDispatch, useAppSelector } from 'src/store';
import AuthSlice from 'src/store/Slices/Base/AuthSlice';
import { useGetKullaniciPrinterQuery } from 'src/services/Printer/PrinterApi';
import { SignalRService, TerminalBilgiResponse } from 'src/services/Printer/SignalRService';
import OrganizasyonYetkiSlice from 'src/store/Slices/Yetki/OrganizasyonYetkiSlice';
import OrganizasyonSecim from 'src/content/pages/Login/OrganizasyonSecim';

// import { logOut } from '../../../../store/actions/user.action';
// import { ClearVwParametrebolumYetki } from 'src/store/actions/parametrebolum.yetki.action';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import { useCHKOlusturMutation } from 'src/services/Dys/DysApi';
import DepoSecimDialog from 'src/content/pages/StokEczane/YetkiIslemleri/DepoSecimDialog';
import DepoTanimSlice from 'src/store/Slices/StokEczane/DepoTanimSlice';
import DialogContent from 'src/components/DialogContent';
import DialogActions from 'src/components/DialogActions';
import DialogTitle from 'src/components/DialogTitle';
import MailAyarlari from 'src/parts/Mail/MailAyarlari';
import Slider from 'src/components/Slider';
import { translate } from 'src/i18n/tHelper';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import { useCrateKullaniciVarsayilanMutation, useGetKullaniciVarsayilanListQuery, useUpdateKullaniciVarsayilanMutation } from 'src/services/Base/GnlKullaniciVarsayilanApi';
import GnlKullanicivarsayilanDTO from 'src/models/Genel/GnlKullanicivarsayilanDTO';
import BaseComponent from 'src/core/base.component';

const CompactHeaderBox = styled(Box)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 6px;
    background: transparent;
    border: 1px solid ${alpha(theme.palette.divider, 0.1)};
    border-radius: 4px;
    min-height: 28px;
    height: 28px;
    width: 100%;
    min-width: 140px;
    max-width: 200px;
    transition: all 0.2s ease;
    cursor: pointer;
    
    &:hover {
      background: ${alpha(theme.palette.primary.main, 0.08)};
      border-color: ${alpha(theme.palette.primary.main, 0.2)};
      transform: translateY(-1px);
      box-shadow: 0 1px 4px ${alpha(theme.palette.primary.main, 0.15)};
    }
`
);

const UserInfoSection = styled(Box)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
    overflow: hidden;
`
);

const ActionButton = styled(IconButton)(
  ({ theme }) => `
    padding: 4px;
    border-radius: 4px;
    color: ${theme.palette.text.secondary};
    
    &:hover {
      background: ${alpha(theme.palette.primary.main, 0.08)};
      color: ${theme.palette.primary.main};
    }
`
);

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            p: 0.3,
            height: 'calc(460px - 70px)',
            overflowY: 'auto',
            overflowX: 'hidden',
            position: 'relative',
            background: (theme) => alpha(theme.palette.background.paper, 0.3),
            '&::-webkit-scrollbar': {
              width: '4px',
              position: 'absolute',
              right: 0,
            },
            '&::-webkit-scrollbar-track': {
              background: (theme) => alpha(theme.palette.divider, 0.03),
              borderRadius: '2px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: (theme) => `linear-gradient(180deg, 
                ${alpha(theme.palette.primary.main, 0.25)}, 
                ${alpha(theme.palette.primary.main, 0.15)})`,
              borderRadius: '2px',
              border: '1px solid transparent',
              backgroundClip: 'padding-box',
              '&:hover': {
                background: (theme) => `linear-gradient(180deg, 
                  ${alpha(theme.palette.primary.main, 0.35)}, 
                  ${alpha(theme.palette.primary.main, 0.25)})`
              }
            },
            scrollbarWidth: 'thin',
            scrollbarColor: (theme) => `${alpha(theme.palette.primary.main, 0.15)} transparent`,
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

const MenuUserBox = styled(Box)(
  ({ theme }) => `
    padding: ${theme.spacing(1.5)};
    background: ${alpha(theme.palette.background.paper, 0.6)};
    border-radius: 0 0 12px 12px;
    margin: 0;
    border: none;
    border-bottom: 1px solid ${alpha(theme.palette.divider, 0.12)};
    position: 'relative';
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
    text-align: left;
    min-width: 0;
    flex: 1;
    overflow: hidden;
    margin-left: 2px;
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
    font-weight: 600;
    color: ${theme.palette.text.primary};
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 0.8rem;
    line-height: 1.2;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
    color: ${theme.palette.text.secondary};
    font-size: 0.7rem;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.1;
    margin-top: 1px;
    opacity: 0.8;
`
);

const CategoryHeader = styled(Box)(
  ({ theme }) => `
    padding: 4px 8px 2px 8px;
    margin: 4px 2px 2px 2px;
    border-bottom: 1px solid ${alpha(theme.palette.divider, 0.08)};
    
    & .MuiTypography-root {
      font-weight: 700;
      font-size: 0.6rem;
      color: ${theme.palette.text.secondary};
      text-transform: uppercase;
      letter-spacing: 0.3px;
      display: flex;
      align-items: center;
      gap: 4px;
    }
`
);

const ModernListItem = styled(Box)(
  ({ theme }) => `
    border-radius: 6px;
    margin: 1px 2px;
    padding: 6px 8px;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    min-height: 26px;
    display: flex;
    align-items: center;
    position: relative;
    border: 1px solid transparent;
    background: ${alpha(theme.palette.background.paper, 0.3)};
    
    &:hover {
      background: ${alpha(theme.palette.primary.main, 0.06)};
      border-color: ${alpha(theme.palette.primary.main, 0.15)};
      transform: translateX(1px);
      box-shadow: 0 1px 4px ${alpha(theme.palette.primary.main, 0.12)};
    }
    
    &:active {
      transform: translateX(0.5px);
      box-shadow: 0 1px 2px ${alpha(theme.palette.primary.main, 0.15)};
    }
    
    & .MuiSvgIcon-root {
      margin-right: 8px;
      font-size: 14px;
      color: ${theme.palette.primary.main};
      transition: all 0.2s ease;
      background: ${alpha(theme.palette.primary.main, 0.08)};
      borderRadius: 4px;
      padding: 3px;
      width: 20px;
      height: 20px;
    }
    
    &:hover .MuiSvgIcon-root {
      background: ${alpha(theme.palette.primary.main, 0.12)};
      transform: scale(1.03);
    }
    
    & .MuiTypography-root {
      font-weight: 500;
      font-size: 0.75rem;
      color: ${theme.palette.text.primary};
      transition: all 0.2s ease;
      flex: 1;
      line-height: 1.2;
    }
    
    &:hover .MuiTypography-root {
      color: ${theme.palette.primary.main};
      font-weight: 600;
    }
    
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 2px;
      height: 0;
      background: ${theme.palette.primary.main};
      border-radius: 0 1px 1px 0;
      transition: height 0.2s ease;
    }
    
    &:hover::before {
      height: 50%;
    }
`
);
const translatePath = "pages|definitions";
const HeaderUserBoxComponent = (): JSX.Element => {
  const [state, setState] = React.useState<printerModel>({
    appVersion: null,
    defaultPrinter: translate(translatePath, 'Printer Seçin'),
    ipAddress: '',
    macAddress: '',
    pcName: '',
    printers: []
  });
  const [terminal, setTerminal] = useState(new SignalRService());
  const [openPrint, setOpenPrint] = React.useState(false);
  const [printer, setPrinter] = useState<PrinterRequest>(new PrinterRequest());
  const [tabValue, setTabValue] = useState(0);

  const userInfo = useAppSelector((s) => s.userLogin);
  const dispatch = useAppDispatch();
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);
  const isDepoOpen = useAppSelector((x) => x.DepoTanim.isDepoSecimDialogOpen);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const navigate = useNavigate();

  const onSignOut = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    navigate('/logout');
  };

  const handleClosePrint = (v: boolean) => {
    setOpenPrint(v);
  };
  const themeContext = useContext(CustomThemeContext);
  const confirm = useConfirmation();
  const seciliBolum = useAppSelector((s) => s.userOrganizasyon);
  const veriKontrol = useAppSelector((s) => s.verikontrol.data.find((f) => f?.id === 990 && f?.deger === 'E'));
  const [chkBul, { isLoading: chkLoading }] = useCHKOlusturMutation();
  const depoInfo = useAppSelector(s => s.DepoTanim.selectedDepo);

  const query = useGetKullaniciPrinterQuery({ kullaniciId: userInfo.userInfo?.id, macAddress: state.macAddress }, { skip: !state.macAddress });

  useEffect(() => {
    if (!query.isFetching && query.data) {
      setPrinter({
        ...printer,
        barcodePrinter: query.data[0]?.barcodePrinter,
        lazerPrinter: query.data[0]?.lazerPrinter,
        kullaniciId: userInfo.userInfo.id
      });
    } else {
      setPrinter({
        ...printer,
        barcodePrinter: localStorage.getItem('barcodePrinter')?.toString(),
        lazerPrinter: localStorage.getItem('laserPrinter')?.toString(),
        kullaniciId: userInfo.userInfo.id
      });
    }
  }, [isOpen, query.isFetching]);

  //Terminalden Terminal bilgileri alınıyor
  const handleBtnClick = async () => {
    try {
      await terminal.connect();
      await terminal.getTerimnalBilgi();
    } catch (error) {
      SnackbarUtils.info(translate(translatePath, 'Terminal Exe ile iletişim kurulamadı!'));
    }
  };
  useEffect(() => {
    if (terminal.hubConn.start) {
      terminal.hubConn.on('GetTerminalBilgiResponse', (response: TerminalBilgiResponse) => {
        setState({
          ...state,
          macAddress: response.macAdres[response.macAdres.length - 1],
          ipAddress: response.ipAdres[response.ipAdres.length - 1],
          pcName: response.terminalAdi,
          printers: response.printers as []
        });
        terminal.disConnect();
      });
    }
  }, [terminal]);
  //Terminalden Terminal bilgileri alındı
  const [openMail, setOpenMail] = useState(false);


  const kullaniciVarsayilanQuery = useGetKullaniciVarsayilanListQuery(userInfo.userInfo?.id);
  const [kullaniciVarsayilanEkle, kullaniciVarsayilanEkleState] = useCrateKullaniciVarsayilanMutation();
  const [kullaniciVarsayilanGuncelle, kullaniciVarsayilanGuncelleState] = useUpdateKullaniciVarsayilanMutation();

  return (
    <>
      {userInfo.newPassword && <SifreDegistir />}
      <CompactHeaderBox onClick={handleOpen} ref={ref}>
        <UserInfoSection>
          <Avatar
            variant="circular"
            alt={userInfo.userInfo.adi}
            src={userInfo.userInfo.foto ? 'data:image/png;base64, ' + userInfo.userInfo.foto : ''}
            sx={{
              width: 24,
              height: 24,
              backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
              color: (theme) => theme.palette.primary.main,
              fontSize: '0.65rem',
              fontWeight: 600
            }}
          >
            {!userInfo.userInfo.foto && `${userInfo.userInfo.adi?.[0]}${userInfo.userInfo.soyadi?.[0]}`}
          </Avatar>
          <UserBoxText>
            <UserBoxLabel>
              {userInfo.userInfo.adi} {userInfo.userInfo.soyadi}
            </UserBoxLabel>
            <UserBoxDescription>
              {userInfo.userInfo.kodu}
            </UserBoxDescription>
          </UserBoxText>
        </UserInfoSection>
        <Tooltip title={translate(translatePath, "Organizasyon Değiştir")} placement="bottom-end" arrow>
          <ActionButton
            onClick={(e) => {
              e.stopPropagation();
              dispatch(OrganizasyonYetkiSlice.actions.setOpen(true));
              handleClose();
            }}
            size="small">
            <ApartmentIcon sx={{ fontSize: '14px' }} />
          </ActionButton>
        </Tooltip>
        <Tooltip title={translate(translatePath, "Çıkış Yap")} placement="bottom-end" arrow>
          <ActionButton onClick={onSignOut} size="small">
            <LockOpenTwoToneIcon sx={{ fontSize: '14px' }} />
          </ActionButton>
        </Tooltip>
      </CompactHeaderBox>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        TransitionComponent={Fade}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
            border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.08)}`,
            width: 300,
            height: 460,
            overflow: 'hidden',
            background: (theme) => `linear-gradient(145deg, 
              ${theme.palette.background.paper} 0%, 
              ${alpha(theme.palette.primary.main, 0.02)} 100%)`,
            backdropFilter: 'blur(20px)',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: (theme) => `linear-gradient(135deg, 
                ${alpha(theme.palette.primary.main, 0.03)} 0%, 
                transparent 50%, 
                ${alpha(theme.palette.secondary.main, 0.02)} 100%)`,
              pointerEvents: 'none'
            }
          }
        }}
      >
        <Box>
          <MenuUserBox sx={{ margin: 0, borderRadius: 0, borderLeft: 0, borderRight: 0, borderTop: 0, padding: '8px 12px' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" position="relative" zIndex={1}>
              <Box display="flex" alignItems="center" gap={1.5}>
                <Box sx={{ position: 'relative' }}>
                  <Avatar
                    variant="circular"
                    alt={userInfo.userInfo.adi}
                    src={userInfo.userInfo.foto ? 'data:image/png;base64, ' + userInfo.userInfo.foto : ''}
                    sx={{
                      width: 32,
                      height: 32,
                      backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
                      color: (theme) => theme.palette.primary.main,
                      border: (theme) => `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                      fontSize: '0.75rem',
                      fontWeight: 700,
                      boxShadow: (theme) => `0 2px 8px ${alpha(theme.palette.primary.main, 0.2)}`,
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: (theme) => `0 4px 12px ${alpha(theme.palette.primary.main, 0.3)}`
                      }
                    }}
                  >
                    {!userInfo.userInfo.foto && `${userInfo.userInfo.adi?.[0]}${userInfo.userInfo.soyadi?.[0]}`}
                  </Avatar>
                  <Box sx={{
                    position: 'absolute',
                    bottom: -2,
                    right: -2,
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    background: (theme) => theme.palette.success.main,
                    border: '2px solid white',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                  }} />
                </Box>
                <UserBoxText>
                  <UserBoxLabel variant="body2" sx={{
                    fontSize: '0.75rem',
                    marginBottom: '2px',
                    lineHeight: 1.2,
                    fontWeight: 600,
                    color: (theme) => theme.palette.text.primary
                  }}>
                    {userInfo.userInfo.adi} {userInfo.userInfo.soyadi}
                  </UserBoxLabel>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    marginBottom: '2px'
                  }}>
                    <BadgeIcon sx={{
                      fontSize: '12px',
                      color: (theme) => theme.palette.text.secondary
                    }} />
                    <UserBoxDescription sx={{
                      fontSize: '0.65rem',
                      lineHeight: 1.2,
                      color: (theme) => theme.palette.text.secondary,
                      fontWeight: 500
                    }}>
                      {userInfo.userInfo.kodu}
                    </UserBoxDescription>
                  </Box>
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                  }}>
                    <EmailIcon sx={{
                      fontSize: '12px',
                      color: (theme) => theme.palette.text.secondary
                    }} />
                    <UserBoxDescription sx={{
                      fontSize: '0.6rem',
                      lineHeight: 1.2,
                      color: (theme) => alpha(theme.palette.text.secondary, 0.8),
                      fontWeight: 400
                    }}>
                      {userInfo.userInfo.email || translate(translatePath, 'Email belirtilmemiş')}
                    </UserBoxDescription>
                  </Box>
                </UserBoxText>
              </Box>
              <Tooltip title={translate(translatePath, "Çıkış Yap")} placement="left" arrow>
                <ActionButton
                  onClick={onSignOut}
                  size="small"
                  sx={{
                    color: (theme) => theme.palette.error.main,
                    padding: '4px',
                    borderRadius: '8px',
                    background: (theme) => alpha(theme.palette.error.main, 0.05),
                    border: (theme) => `1px solid ${alpha(theme.palette.error.main, 0.1)}`,
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      background: (theme) => alpha(theme.palette.error.main, 0.1),
                      color: (theme) => theme.palette.error.main,
                      transform: 'scale(1.05)',
                      boxShadow: (theme) => `0 2px 8px ${alpha(theme.palette.error.main, 0.2)}`
                    }
                  }}
                >
                  <LockOpenTwoToneIcon sx={{ fontSize: '18px' }} />
                </ActionButton>
              </Tooltip>
            </Box>
          </MenuUserBox>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              minHeight: 28,
              height: 28,
              background: (theme) => `linear-gradient(90deg, 
                ${alpha(theme.palette.background.paper, 0.9)} 0%, 
                ${alpha(theme.palette.primary.main, 0.01)} 50%, 
                ${alpha(theme.palette.background.paper, 0.9)} 100%)`,
              position: 'relative',
              '&::before': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: '15%',
                right: '15%',
                height: '1px',
                background: (theme) => `linear-gradient(90deg, 
                  transparent 0%, 
                  ${alpha(theme.palette.primary.main, 0.2)} 50%, 
                  transparent 100%)`
              },
              '& .MuiTab-root': {
                minHeight: 28,
                height: 28,
                fontSize: '0.65rem',
                fontWeight: 600,
                textTransform: 'none',
                padding: '2px 8px',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                borderRadius: '6px 6px 0 0',
                margin: '0 1px',
                position: 'relative',
                color: (theme) => theme.palette.text.secondary,
                '&.Mui-selected': {
                  color: (theme) => theme.palette.primary.main,
                  background: (theme) => alpha(theme.palette.primary.main, 0.06),
                  fontWeight: 700,
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: '25%',
                    right: '25%',
                    height: '2px',
                    background: (theme) => theme.palette.primary.main,
                    borderRadius: '1px 1px 0 0'
                  }
                },
                '&:hover:not(.Mui-selected)': {
                  background: (theme) => alpha(theme.palette.primary.main, 0.03),
                  color: (theme) => theme.palette.primary.main,
                },
                '& .MuiSvgIcon-root': {
                  fontSize: '14px',
                  transition: 'all 0.2s ease'
                },
                '&.Mui-selected .MuiSvgIcon-root': {
                  transform: 'scale(1.05)',
                  filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.08))'
                }
              },
              '& .MuiTabs-indicator': {
                display: 'none'
              }
            }}
          >
            <Tab
              icon={<AccountCircleIcon sx={{ fontSize: 14 }} />}
              label={translate(translatePath, "Profil")}
              iconPosition="start"
              sx={{ gap: 0.3 }}
            />
            <Tab
              icon={<SettingsIcon sx={{ fontSize: 14 }} />}
              label={translate(translatePath, "Ayarlar")}
              iconPosition="start"
              sx={{ gap: 0.3 }}
            />
          </Tabs>
          <TabPanel value={tabValue} index={0}>
            <CategoryHeader>
              <Typography>
                <PersonIcon sx={{ fontSize: '12px', marginRight: '4px', color: 'primary.main' }} />
                {translate(translatePath, 'Hesap İşlemleri')}
              </Typography>
            </CategoryHeader>

            <ModernListItem
              onClick={() => {
                dispatch(AuthSlice.actions.setNewPassword(true));
                handleClose();
              }}
            >
              <PasswordIcon />
              <Typography>{translate(translatePath, 'Şifre Değiştir')}</Typography>
            </ModernListItem>

            <ModernListItem
              onClick={() => {
                setOpenMail(true);
                handleClose();
              }}
            >
              <Mail />
              <Typography>{translate(translatePath, 'Mail Ayarları')}</Typography>
            </ModernListItem>

            <CategoryHeader>
              <Typography>
                <SaveIcon sx={{ fontSize: '12px', marginRight: '4px', color: 'info.main' }} />
                {translate(translatePath, 'İndirmeler')}
              </Typography>
            </CategoryHeader>

            <ModernListItem
              onClick={() => {
                window.open("https://mkm.ventura.com.tr:10443/OrigoTerminalSmartClient/publish.html", "_blank");
              }}
            >
              <CloudDownload />
              <Typography>{translate(translatePath, 'Origo Terminal İndir')}</Typography>
            </ModernListItem>

            {veriKontrol?.deger === 'E' && (
              <>
                <CategoryHeader>
                  <Typography>
                    <AssignmentIcon sx={{ fontSize: '12px', marginRight: '4px', color: 'warning.main' }} />
                    {translate(translatePath, 'Dış Sistemler')}
                  </Typography>
                </CategoryHeader>

                <ModernListItem
                  onClick={async () => {
                    if (!chkLoading)
                      await chkBul()
                        .unwrap()
                        .then((res) => {
                          let tempLink = document.createElement('a');
                          tempLink.href = `${veriKontrol.kontrol}/?ModulPK=90&LoginId=${userInfo.userInfo.id}&CHK=${res}`;
                          tempLink.target = '_blank';
                          tempLink.click();
                        })
                        .catch((e) => e);
                  }}
                >
                  <FindInPageIcon />
                  <Typography>{translate(translatePath, 'Döküman Yönetim Sistemi')}</Typography>
                </ModernListItem>
              </>
            )}
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            <CategoryHeader>
              <Typography>
                <SettingsIcon sx={{ fontSize: '12px', marginRight: '4px', color: 'grey.600' }} />
                {translate(translatePath, 'Genel Ayarlar')}
              </Typography>
            </CategoryHeader>

            <ModernListItem
              onClick={async () => {
                if (!kullaniciVarsayilanQuery.isFetching && !kullaniciVarsayilanEkleState.isLoading && !kullaniciVarsayilanGuncelleState.isLoading) {
                  const kontrol = kullaniciVarsayilanQuery.data?.find((f) => f.ekranAd === "USERBOX" && f.kontrolad === "UB_MENUAYAR");
                  if (kontrol?.id > 0) {
                    await kullaniciVarsayilanGuncelle({ ...kontrol, deger: kontrol?.deger === "E" ? "H" : "E" }).unwrap().then(() => { }).catch(e => e);
                    return;
                  }
                  else {
                    let veri: GnlKullanicivarsayilanDTO = {
                      ...new GnlKullanicivarsayilanDTO(),
                      ekranAd: "USERBOX",
                      kontrolad: "UB_MENUAYAR",
                      deger: helper.objectToString("E"),
                      fkGnlKullanici: userInfo.userInfo?.id
                    };
                    await kullaniciVarsayilanEkle(veri).unwrap().then(() => { }).catch(e => e);
                  }
                }
              }}
            >
              {(!kullaniciVarsayilanQuery.isFetching && typeof kullaniciVarsayilanQuery?.data !== "undefined") && kullaniciVarsayilanQuery.data?.find((f) => f.ekranAd === "USERBOX" && f.kontrolad === "UB_MENUAYAR")?.deger === "E" ? (
                <>
                  <MenuIcon />
                  <Typography>{translate(translatePath, 'Menü Kapanmasın')}</Typography>
                </>
              ) : (
                <>
                  <MenuOpenIcon />
                  <Typography>{translate(translatePath, 'Menü Kapansın')}</Typography>
                </>
              )}
            </ModernListItem>

            <CategoryHeader>
              <Typography>
                <BusinessIcon sx={{ fontSize: '12px', marginRight: '4px', color: 'secondary.main' }} />
                {translate(translatePath, 'Organizasyon')}
              </Typography>
            </CategoryHeader>

            <ModernListItem
              onClick={(e) => {
                dispatch(OrganizasyonYetkiSlice.actions.setOpen(true));
                handleClose();
              }}
            >
              <ApartmentIcon />
              <Typography>{seciliBolum.organizasyon.organizasyon}</Typography>
            </ModernListItem>

            <ModernListItem
              onClick={(e) => {
                dispatch(DepoTanimSlice.actions.setIsDepoSecimDialogOpen(true));
                handleClose();
              }}
            >
              <TaskAlt />
              <Typography>{`${translate(translatePath, 'Depo Seçim')} ${depoInfo?.depoAdi ? `(${depoInfo.depoAdi})` : ''}`}</Typography>
            </ModernListItem>

            <CategoryHeader>
              <Typography>
                <PrintIcon sx={{ fontSize: '12px', marginRight: '4px', color: 'error.main' }} />
                {translate(translatePath, 'Donanım')}
              </Typography>
            </CategoryHeader>

            <ModernListItem
              onClick={() => {
                handleBtnClick();
                setOpenPrint(true);
              }}
            >
              <PrintRounded />
              <Typography>{translate(translatePath, 'Yazıcı Seçimi')}</Typography>
            </ModernListItem>

            <CategoryHeader>
              <Typography>
                <PaletteIcon sx={{ fontSize: '12px', marginRight: '4px', color: 'success.main' }} />
                {translate(translatePath, 'Görünüm')}
              </Typography>
            </CategoryHeader>

            <Box sx={{
              padding: '6px 8px',
              background: (theme) => alpha(theme.palette.primary.main, 0.04),
              borderRadius: '8px',
              margin: '2px 4px',
              border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
            }}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '6px'
              }}>
                <Typography variant="caption" sx={{
                  fontSize: '0.7rem',
                  fontWeight: 600,
                  color: 'primary.main',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5
                }}>
                  <PaletteIcon sx={{ fontSize: '12px', color: 'primary.main' }} />
                  {translate(translatePath, 'Tema Modu')}
                </Typography>
                <Box sx={{
                  display: 'flex',
                  background: (theme) => alpha(theme.palette.divider, 0.08),
                  borderRadius: '12px',
                  padding: '2px',
                  gap: '1px'
                }}>
                  <Box
                    onClick={() => themeContext.setMode('light')}
                    sx={{
                      padding: '2px 6px',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      fontSize: '0.6rem',
                      fontWeight: 500,
                      background: themeContext.mode === 'light'
                        ? (theme) => theme.palette.primary.main
                        : 'transparent',
                      color: themeContext.mode === 'light'
                        ? 'white'
                        : (theme) => theme.palette.text.secondary,
                      '&:hover': {
                        background: themeContext.mode === 'light'
                          ? (theme) => theme.palette.primary.main
                          : (theme) => alpha(theme.palette.primary.main, 0.1)
                      }
                    }}
                  >
                    <LightModeIcon sx={{ fontSize: '10px', marginRight: '2px', color: '#FFA726' }} />
                    Light
                  </Box>
                  <Box
                    onClick={() => themeContext.setMode('dark')}
                    sx={{
                      padding: '2px 6px',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      fontSize: '0.6rem',
                      fontWeight: 500,
                      background: themeContext.mode === 'dark'
                        ? (theme) => theme.palette.primary.main
                        : 'transparent',
                      color: themeContext.mode === 'dark'
                        ? 'white'
                        : (theme) => theme.palette.text.secondary,
                      '&:hover': {
                        background: themeContext.mode === 'dark'
                          ? (theme) => theme.palette.primary.main
                          : (theme) => alpha(theme.palette.primary.main, 0.1)
                      }
                    }}
                  >
                    <DarkModeIcon sx={{ fontSize: '10px', marginRight: '2px', color: '#5C6BC0' }} />
                    Dark
                  </Box>
                </Box>
              </Box>
              <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: 0.5
              }}>
                <ThemeChoose />
              </Box>
            </Box>
            <Box sx={{
              padding: '4px 6px',
              background: (theme) => alpha(theme.palette.secondary.main, 0.03),
              borderRadius: '4px',
              margin: '2px 4px',
              border: (theme) => `1px solid ${alpha(theme.palette.secondary.main, 0.08)}`
            }}>
              <Typography variant="caption" sx={{
                fontSize: '0.65rem',
                fontWeight: 600,
                color: 'secondary.main',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                marginBottom: '3px'
              }}>
                <ViewSidebarIcon sx={{ fontSize: '12px', color: 'secondary.main' }} />
                {translate(translatePath, 'Sidebar')}
              </Typography>
              <Stack direction="row" spacing={0.25} flexWrap="wrap" justifyContent="center">
                <Chip
                  label={translate(translatePath, "Beyaz")}
                  variant={themeContext.navMode === 'white' ? 'filled' : 'outlined'}
                  size="small"
                  color={themeContext.navMode === 'white' ? 'secondary' : 'default'}
                  sx={{
                    fontSize: '0.55rem',
                    height: '16px',
                    borderRadius: '8px',
                    fontWeight: 500,
                    minWidth: '45px',
                    '& .MuiChip-label': { padding: '0 4px' },
                    transition: 'all 0.2s ease'
                  }}
                  onClick={(e) => {
                    themeContext.setNavMode('white');
                  }}
                />
                <Chip
                  label={translate(translatePath, "Şeffaf")}
                  variant={themeContext.navMode === 'transparent' ? 'filled' : 'outlined'}
                  size="small"
                  color={themeContext.navMode === 'transparent' ? 'secondary' : 'default'}
                  sx={{
                    fontSize: '0.55rem',
                    height: '16px',
                    borderRadius: '8px',
                    fontWeight: 500,
                    minWidth: '40px',
                    '& .MuiChip-label': { padding: '0 4px' },
                    transition: 'all 0.2s ease'
                  }}
                  onClick={(e) => {
                    themeContext.setNavMode('transparent');
                  }}
                />
                <Chip
                  label={translate(translatePath, "Koyu")}
                  variant={themeContext.navMode === 'dark' ? 'filled' : 'outlined'}
                  size="small"
                  color={themeContext.navMode === 'dark' ? 'secondary' : 'default'}
                  sx={{
                    fontSize: '0.55rem',
                    height: '16px',
                    borderRadius: '8px',
                    fontWeight: 500,
                    minWidth: '35px',
                    '& .MuiChip-label': { padding: '0 4px' },
                    transition: 'all 0.2s ease'
                  }}
                  onClick={(e) => {
                    themeContext.setNavMode('dark');
                  }}
                />
              </Stack>
            </Box>
            <Box sx={{
              padding: '4px 6px',
              background: (theme) => alpha(theme.palette.success.main, 0.03),
              borderRadius: '4px',
              margin: '2px 4px',
              border: (theme) => `1px solid ${alpha(theme.palette.success.main, 0.08)}`
            }}>
              <Typography variant="caption" sx={{
                fontSize: '0.65rem',
                fontWeight: 600,
                color: 'success.main',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                marginBottom: '3px'
              }}>
                <FormatSizeIcon sx={{ fontSize: '12px', color: 'success.main' }} />
                {translate(translatePath, 'Size')} ({userInfo.formSize}px)
              </Typography>
              <Box sx={{ paddingX: '2px' }}>
                <Slider
                  defaultValue={12}
                  value={userInfo.formSize}
                  max={16}
                  min={10}
                  size="small"
                  valueLabelDisplay="auto"
                  sx={{
                    height: 4,
                    color: 'success.main',
                    '& .MuiSlider-thumb': {
                      width: 12,
                      height: 12,
                      background: (theme) => theme.palette.success.main,
                      border: '1px solid #fff',
                      boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                      '&:hover': {
                        boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                      }
                    },
                    '& .MuiSlider-valueLabel': {
                      fontSize: '0.55rem',
                      background: (theme) => theme.palette.success.main,
                      fontWeight: 600,
                      minWidth: '20px',
                      height: '18px',
                      lineHeight: '18px'
                    },
                    '& .MuiSlider-track': {
                      height: 4,
                      borderRadius: 2,
                      background: (theme) => `linear-gradient(90deg, ${alpha(theme.palette.success.main, 0.3)}, ${theme.palette.success.main})`
                    },
                    '& .MuiSlider-rail': {
                      height: 4,
                      borderRadius: 2,
                      background: (theme) => alpha(theme.palette.success.main, 0.1)
                    }
                  }}
                  onChange={(e, v) => dispatch(AuthSlice.actions.setFormSize(helper.objectToNumber(v)))}
                />
              </Box>
            </Box>
          </TabPanel>
        </Box>
      </Popover>
      {isDepoOpen && <DepoSecimDialog />}
      <Dialog
        fullWidth
        open={openPrint}
        onClose={handleClose}
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Formik
          enableReinitialize={true}
          initialValues={printer}
          onSubmit={(values) => {
            KullaniciPrinterDTOService.find({
              paging: false,
              pageIndex: 0,
              pageSize: 0,
              filters: {
                groupOperator: 'and',
                predicates: [
                  {
                    fieldName: 'kullaniciId',
                    operator: '=',
                    value1: userInfo.userInfo.id
                  },
                  {
                    fieldName: 'macAddress',
                    operator: '=',
                    value1: state.macAddress
                  }
                ]
              },
              sorts: helper.convertApiSorts([], {
                fieldName: 'kullaniciId',
                ascending: true
              })
            })
              .then((bul) => {
                KullaniciPrinterDTOService.UserPrinterUpdate({
                  ...values,
                  kullaniciId: bul.data[0].kullaniciId,
                  macAddress: state.macAddress
                }).then((res) => {
                  if (res.responseCode != 200) {
                    confirm({
                      description: res.errorMessage,
                      title: '',
                      variant: 'info'
                    });
                    return;
                  }
                  query.refetch();
                  setPrinter({
                    ...printer,
                    ...values
                  });
                  SnackbarUtils.success(translate(translatePath, 'Başarıyla güncellendi.'));
                  setOpenPrint(false);
                });
              }).catch((error) => {
                KullaniciPrinterDTOService.UserPrinterInsert({
                  ...values,
                  kullaniciId: userInfo.userInfo.id,
                  macAddress: state.macAddress
                }).then((res) => {
                  if (res.responseCode != 200) {
                    confirm({
                      description: res.errorMessage,
                      title: '',
                      variant: 'info'
                    });
                    return;
                  }
                  setPrinter({
                    ...printer,
                    ...values
                  });
                  SnackbarUtils.success(translate(translatePath, 'Başarıyla kayıt eklendi.'));
                  setOpenPrint(false);
                  query.refetch();
                });
              });
          }}
        >
          {(formik) => (
            <BaseComponent loading={query.isFetching}>
              <DialogTitle>{translate(translatePath, 'Yazıcı Seçimi')}</DialogTitle>
              <DialogContent>
                <Grid container sx={{ paddingTop: 1, justifyContent: 'right' }}>
                  <Grid item>
                    <Select
                      id="select-multiple-native"
                      native
                      value={formik.values.lazerPrinter}
                      name="lazerPrinter"
                      label={translate(translatePath, 'Lazer/Mürekkep Yazıcı')}
                      onChange={(e) => {
                        formik.handleChange(e);
                        setState((prev) => ({
                          ...prev,
                          defaultPrinter: e.target.value.toString()
                        }));
                        // printService.setprinter(e.target.value.toString())
                        //   .then((res) => {
                        //     if (res.status !== 200)
                        //       notify.error(res.statusText);

                        //     helper.setLaserPrintTolocaLStorage();
                        //   })
                        //   .catch(() => { })
                      }}
                      inputProps={{
                        id: 'select-multiple-native'
                      }}
                    >
                      <option key={'0'} value={'0'}>
                        {translate(translatePath, 'Yazıcı Seçin')}
                      </option>
                      {state &&
                        state.printers.map((v) => (
                          <option key={v} value={v}>
                            {v}
                          </option>
                        ))}
                    </Select>
                  </Grid>
                  <Grid item>
                    <Select
                      id="select-multiple-native"
                      native
                      value={formik.values.barcodePrinter}
                      name="barcodePrinter"
                      label={translate(translatePath, 'Barcode Yazıcı')}
                      onChange={(e) => {
                        formik.handleChange(e);
                        setState((prev) => ({
                          ...prev,
                          defaultPrinter: e.target.value.toString()
                        }));
                        printService
                          .setprinter(e.target.value.toString())
                          .then((res) => {
                            if (res.status !== 200) notify.error(res.statusText);

                            helper.setBarcodePrintTolocaLStorage();
                          })
                          .catch(() => { });
                      }}
                      inputProps={{
                        id: 'select-multiple-native'
                      }}
                    >
                      <option key={'0'} value={'0'}>
                        {translate(translatePath, 'Yazıcı Seçin')}
                      </option>
                      {state &&
                        state.printers.map((v) => (
                          <option key={v} value={v}>
                            {v}
                          </option>
                        ))}
                    </Select>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <SrcButton customType="save" onClick={formik.submitForm}>
                  {translate(translatePath, 'Kaydet')}
                </SrcButton>
                <SrcButton customType="close" onClick={() => handleClosePrint(false)}>
                  {translate(translatePath, 'Çıkış')}
                </SrcButton>
              </DialogActions>
            </BaseComponent>
          )}
        </Formik>
      </Dialog>
      <OrganizasyonSecim menuden={true} />
      {openMail && <MailAyarlari onClose={() => setOpenMail(false)} open={openMail} />}
    </>
  );
};
const HeaderUserbox = () => {
  return <HeaderUserBoxComponent />;
};

export default HeaderUserbox;
